import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=204f13db&scoped=true"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"
import style0 from "./MyTable.vue?vue&type=style&index=0&id=204f13db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f13db",
  null
  
)

export default component.exports